import React from "react"
import style from "./validationText.module.scss"

const ValidationText = ({ message, show }) => {
  return show ? <p className={style.message}>{message}</p> : null
}

export default ValidationText
